import logo from './logo.svg';
import './App.css';
import GradientsGenerator from './Components/GradientsGenerator';
import FloatingButton from './Components/FloatingButton'

function App() {
  return (
   <>
   <GradientsGenerator />
   <FloatingButton />
   </>
  );
}

export default App;
